import { GEOLOCATION_LOCAL_STORAGE_KEY } from '../constants';

/**
 * Checks localStorage for information if user closed geolocation popup before.
 * If he closed it in the last month, it will return true.
 */
export const getHiddenByUser = (): boolean => {
  const hideGeolocationUntilFromLocalStorage = localStorage.getItem(GEOLOCATION_LOCAL_STORAGE_KEY);
  const hideGeolocationUntil = hideGeolocationUntilFromLocalStorage
    ? new Date(hideGeolocationUntilFromLocalStorage)
    : null;
  const dateNow = new Date();

  return (
    hideGeolocationUntil != null &&
    hideGeolocationUntil.toString() !== 'Invalid Date' &&
    hideGeolocationUntil >= dateNow
  );
};

/**
 * Sets date to localStorage to hide geolocation popup for a month.
 */
export const setHideGeolocationUntilDate = () => {
  const dateNow = new Date();
  dateNow.setMonth(dateNow.getMonth() + 1);
  localStorage.setItem(GEOLOCATION_LOCAL_STORAGE_KEY, dateNow.toISOString());
};
